export enum ModalType {
  ApplicationsUpsellModal,
  AttachmentModal,
  AttachmentsUploader,
  CustomizedBlockedModal,
  BlockedModalFromModule,
  ContactInfoCallModal,
  DeleteAttachmentsModal,
  FiltersSelector,
  ImagesViewer,
  NotesModal,
  PersonalContactDetailsWarningModal,
  RenterDetailsModal,
  RenterProfileModal,
  ReportConversationModal,
  RequestRenterProfileModal,
  SavedReplyModal,
  SendApplicationConfirmationModal,
  SendMessageModal,
  TourSchedulingUpsellModal,
}
